<svg-icon class="!inline-flex items-center {{color}}" key="loading-animated" [fontSize]="font_size"></svg-icon>
